// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:01:17

export default {
  "id": "racing-pinball",
  "slug": "racing-pinball",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/2a1beff87071466a90c4e30c0bfab6a2-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/2a1beff87071466a90c4e30c0bfab6a2/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Racing Pinball",
      "description": "\"Racing Pinball\" is a fast-paced arcade game that brings the timeless thrill of pinball to your device!\nLaunch the ball into action and use flippers to keep it in play, racking up points by hitting bumpers, targets, and ramps.\n\"Racing Pinball\" needs skill and reflexes in a classic, addictive experience where the goal is simple: keep the ball rolling and aim for the high score!",
      "instructions": "Use space to launch the ball. \nUse arrow keys to operate the flippers.",
      "genres": [
        "Casual",
        "Racing & Driving"
      ],
      "tags": [
        "arcade",
        "car",
        "classic",
        "flip"
      ]
    },
    "zh-CN": {
      "title": "赛车弹球",
      "description": "《赛车弹球》是一款节奏快速的电玩游戏，将经典的弹球乐趣带给您的设备！将球发射进入游戏，利用弹杆保持球在游戏中，通过撞击挡板、目标和斜坡来累积分数。\n《赛车弹球》需要技巧和反应，在经典且上瘾的游戏体验中，目标简单：保持球滚动并争取高分！",
      "instructions": "使用空格键发射球。\n使用箭头键操作挡板。",
      "genres": [
        "休闲",
        "赛车与驾驶"
      ],
      "tags": [
        "街机",
        "汽车",
        "经典",
        "翻转"
      ]
    },
    "zh-TW": {
      "title": "賽車彈珠機",
      "description": "“競速搖桿”是一款快節奏的街機遊戲，將經典的搖桿樂趣帶到您的設備上！發射球進行動作，使用發條來保持球在遊戲中，通過擊中邊緣、目標和斜坡來積分。\n“競速搖桿”需要技巧和反應能力，在經典且上癮的體驗中，目標簡單：讓球不斷滚动，並追求高分！",
      "instructions": "使用空格鍵發射球。\n使用方向鍵操作保壘。",
      "genres": [
        "休閒",
        "賽車與駕駛"
      ],
      "tags": [
        "街機",
        "車",
        "經典",
        "翻轉"
      ]
    },
    "zh-HK": {
      "title": "賽車滾珠機",
      "description": "「賽車波子機」是一款快節奏的街機遊戲，將經典的波子機刺激快感帶到你手中的裝置！將球發射進入遊戲，使用波子機的撥桿來保持球在遊戲中，透過擊中擊柱、目標和斜坡來累積分數。\n「賽車波子機」需要技巧和反應速度，在一個經典、上癮的體驗中，目標簡單：保持球不停止並射擊高分！",
      "instructions": "用空格鍵發射球。\n用方向鍵操控搖桿。",
      "genres": [
        "休闲",
        "賽車及駕駛"
      ],
      "tags": [
        "街機",
        "車",
        "經典",
        "翻轉"
      ]
    },
    "ja": {
      "title": "レーシングピンボール",
      "description": "“レーシングピニボール”は、高速で楽しいアーケードゲームで、時代を超越したピニボールの興奮をデバイスに持ち込んでいます！ボールを動き出させ、フリッパーを使ってプレイを続け、バンプ、ターゲット、ランプに当てることでポイントを稼ぎます。\n\n“レーシングピニボール”は、単純なゴールを目指すカリスマ性と反応力が必要な、クラシックで魅力的な体験です。ゴールはシンプル：ボールを回し続け、高得点を目指せ！",
      "instructions": "スペースを押してボールを打つ。\nアローキーを使ってフリッパーを操作する。",
      "genres": [
        "カジュアル",
        "レーシング & ドライビング"
      ],
      "tags": [
        "アーケード",
        "車",
        "クラシック",
        "フリップ"
      ]
    },
    "ko": {
      "title": "레이싱 피닐볼",
      "description": "\"레이싱 핀볼\"은 빠른 템포의 아케이드 게임으로 영원한 핀볼의 설레림을 기기에 가져옵니다!\n공을 활성화하여 플립버드를 사용하여 게임을 유지하고, 부분, 타겟, 램프를 맞추어 점수를 획득하세요.\n\"레이싱 핀볼\"은 기본적인 경험에서 기술과 반응 속도가 필요하며 목표는 간단합니다: 공을 계속 돌리고 최고점을 목표로하세요!",
      "instructions": "공간바로 누르기로 공을 발사하세요. 방향키로 플립per를 조작하세요.",
      "genres": [
        "캐주얼",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "아케이드",
        "자동차",
        "클래식",
        "플립"
      ]
    },
    "fr": {
      "title": "Course de flipper",
      "description": "\"Racing Pinball\" est un jeu d'arcade rapide qui apporte le thrilling éternel du flipper sur votre appareil !\nLancez la balle dans l'action et utilisez les flippers pour la garder en jeu, accumulant des points en frappant les bumpers, les cibles et les rampes.\n\"Racing Pinball\" nécessite de la compétence et des réflexes dans une expérience classique et addictive où l'objectif est simple : garder la balle en movement et viser le score le plus élevé !",
      "instructions": "Utilisez l'espace pour lancer la balle.\nUtilisez les flèches pour操纵 les flippers.",
      "genres": [
        "Facile",
        "Course et Conduite"
      ],
      "tags": [
        "arcade",
        "voiture",
        "classique",
        "flip"
      ]
    }
  }
};
